import React from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import chevronRightIcon from 'assets/images/rightb.png';
import SimpleBar from 'simplebar-react';
import { LocationFilter } from 'components/molecules/locationFilter';
import { SizeFilter } from 'components/molecules/sizeFilter';
import { useViewport } from 'components/templates/viewportProvider';
import { CompletedYearFilter } from 'components/molecules/completedYearFilter';
import { ProjectSelector } from 'modules/project/selector';
import { ProjectActions } from 'modules/project/actions';
import { StatusFilters } from 'components/molecules/statusFilter';

const ArchitectureDesignFilters = props => {
  const { isMobile } = useViewport();
  const {
    isOpen,
    onClosePress,
    filters,
    activeFilters,
    toggleProjectFilter,
    clearProjectFilters,
  } = props;
  if (!filters) {
    return null;
  }

  const onClose = () => {
    onClosePress();
  };

  const toggleLocation = option => {
    toggleProjectFilter('location', option.id);
  };

  const toggleStatus = option => {
    toggleProjectFilter('projectStatus', option.id);
  };

  const changeSize = value => {
    toggleProjectFilter('size', value);
  };

  const changeYear = value => {
    toggleProjectFilter('year', value);
  };

  const clearAllFilters = e => {
    e.preventDefault();
    clearProjectFilters();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClosePress}
      overlayClassName={'modal-overlay normal-scroll'}
      className={`project-filters-overlay-content ${isMobile ? 'mobile' : ''}`}
    >
      <div className={'project-filters-modal'}>
        <a className={'collapse-icon-container'} onClick={onClose}>
          <img src={chevronRightIcon} alt={'icon'} />
        </a>
        {!isMobile && <span className={'modal-title'}>Filters</span>}
        <a className={'modal-button'} onClick={clearAllFilters} href={'#'}>
          Clear All
        </a>
        <SimpleBar autoHide={true} style={{ height: '100%' }}>
          <div className={'project-filters-content'}>
            <div className={'filters-header'}>
              <h3>Looking for something specific?</h3>
              {!isMobile && (
                <p>
                  Filter by location, project status, and year of completion.
                </p>
              )}
            </div>
            <div className={'filter-set'}>
              <StatusFilters
                activeFilters={activeFilters.projectStatus}
                toggleFilter={type => toggleStatus(type)}
                options={filters.projectStatus}
              />
              <SizeFilter
                min={filters.size.min}
                max={filters.size.max}
                values={activeFilters.size ? [activeFilters.size] : null}
                onChange={value => changeSize(value)}
              />
              <CompletedYearFilter
                min={filters.year.min}
                max={filters.year.max}
                values={activeFilters.year ? [activeFilters.year] : null}
                onChange={value => changeYear(value)}
              />
              <LocationFilter
                activeFilters={activeFilters.location}
                toggleFilter={city => toggleLocation(city)}
                options={filters.location}
              />
            </div>
          </div>
        </SimpleBar>
      </div>
    </Modal>
  );
};

const mapStateToProps = state => {
  return {
    filters: ProjectSelector.getProjectFilters(state),
    activeFilters: ProjectSelector.getActiveProjectFilters(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { toggleProjectFilter, clearProjectFilters } = ProjectActions;
  return bindActionCreators(
    {
      toggleProjectFilter,
      clearProjectFilters,
    },
    dispatch
  );
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(ArchitectureDesignFilters);

export { connectedComponent as ArchitectureDesignFilters };
